import React from 'react';
import MultipleEmployeeApproval from './MultipleEmployeeApproval';
import { AiOutlineClose } from "react-icons/ai";
// import DropOutModal from '../../../components/ModalComponents/DropOutModal';
// import ShareModal from '../../../components/ModalComponents/ShareModal';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz"; 
import SendHireModalComponent from '../../../components/ModalComponents/SendHireModalComponent';

function SendHireDrawerComponent({ isOpen, onClose, data, id }: any) {

 

	const drawerClassName = `drawer-container ${isOpen ? 'drawer-open' : ''}`;

	return (
		<div className={drawerClassName}>
			<div className='times_container'>
				<div className='times_container_sup'>
					<h2>Applicants</h2>
					<div className="dropdown">
						<button className="dropbtn">
							<MoreHorizIcon />
						</button>
						<div className="dropdown-content">
							<a>
								<SendHireModalComponent
         title="Send for Hire"
         name={data} 
         applicationIds={id} 
                  	/>
							</a>

						</div>
					</div>
				</div>
				<button onClick={onClose} className="close-button">
					<AiOutlineClose />
				</button>
			</div>

			<div className="drawer-content">
				{/* Add your drawer content here */}
				<MultipleEmployeeApproval data={data} />
			</div>
		</div>
	);
}

export default SendHireDrawerComponent;